import { render, staticRenderFns } from "./ViewSupplierResources.vue?vue&type=template&id=361f1526&scoped=true&"
import script from "./ViewSupplierResources.vue?vue&type=script&lang=js&"
export * from "./ViewSupplierResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361f1526",
  null
  
)

export default component.exports